import { Link } from "react-router-dom";
import { Button, Nav, Navbar, NavbarBrand, NavItem, NavLink } from "reactstrap";
import BonusPoints from "../../../components/bonifiedInteractions/BonusPoints";
import keycloak from "../../../keycloak";
import { isLoggedIn } from "../../../store/actions/LoginActions";
import { UrlPathBonifiedInteractions, UrlPathMain } from "../../../url";
import { SelectTheme } from "../../SwitchTheme";
import logo from "../images/BBLogo.svg";
import logoutIcon from "../images/Konto.svg";

export const Header = () => {
  const logoutAndRedirect = () => {
    keycloak.logout();
  };
  return (
    <header>
      <Navbar expand="xs">
        <NavbarBrand tag={isLoggedIn() ? Link : undefined} to={isLoggedIn() ? UrlPathMain : undefined}>
          <img
            src={logo}
            style={{
              height: 103,
              paddingLeft: 440,
            }}
            alt="Bijou Brigitte"
          />
        </NavbarBrand>
        <Nav className="ml-auto" navbar>
          {isLoggedIn() && (
            <>
              <NavItem>
                <NavLink tag={Link} to={UrlPathBonifiedInteractions} style={{ textAlign: "center" }}>
                  <div style={{ marginTop: "6px", marginBottom: "-2px" }}>
                    <b>
                      <BonusPoints />
                    </b>
                  </div>
                  <span style={{ fontSize: 10 }}>Deine Punkte</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <Button color="link" onClick={logoutAndRedirect}>
                  <img src={logoutIcon} style={{ width: 24 }} alt="Logout" />
                  <br />
                  <span style={{ fontSize: 10 }}>Logout</span>
                </Button>
              </NavItem>
            </>
          )}
          <NavItem>
            <div style={{ paddingTop: 16 }}>
              <SelectTheme />
            </div>
          </NavItem>
        </Nav>
      </Navbar>
    </header>
  );
};
